export default __webpack_public_path__ + "static/media/IconUserActive.988966e0.svg";